export default __webpack_public_path__ + "static/media/welcome-switch-org.ea779aee.png";